import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  GetLeaveList,
  GetRejoinLeaveList,
} from "../../Repository/Api";
import moment from "moment";
import { Link } from "react-router-dom";
import { errorMsg } from "../Toastify";
import MUIDataTable from "mui-datatables";
import { DateRangePicker } from "react-date-range";
import { enUS } from 'date-fns/locale';

const Staffleavestatus = () => {
  const { first_name, desingation, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const [leaveList, setLeaveList] = useState([]);
  // console.log(leaveList, "date range 2")
  const [rejoinLeaveList, setRejoinLeaveList] = useState([]);
  const [rejoinLeaveList1, setRejoinLeaveList1] = useState([]);
  const [dateFilterOpen, setDateFilterOpen] = useState(false)


  const filterIntialState = [
    {
      startDate: null,
      endDate: new Date('2030-01-01'),
      key: "selection",
    },
  ]

  const [range, setRange] = useState(filterIntialState);
  // console.log(range[0].startDate, "date range")
  const handleSelect = (ranges) => {
    setRange([ranges.selection]);
  };

  const [activetag, setActivetag] = useState(0);
  const linkstag = ["Applied Leave", "Cancelled Leave", "Rejoin"];
  const showSelectedtag = (index) => {
    setActivetag(index);
  };
  useEffect(() => {
    getLeaveList();
  }, [range]);
  const [active, setActive] = useState(0);
  const links = [
    "Pending",
    "Approved",
    "Rejected",
    "Intimated (Out of Station)",
  ];
  const showSelected = (index) => {
    setActive(index);
  };

  const [activeone, setActiveone] = useState(0);
  const [activetwo, setActivetwo] = useState(0);
  const linksone = ["Pending", "Approved", "Rejected"];
  const linkstwo = ["Pending", "Submitted"];
  const showSelectedone = (index) => {
    setActiveone(index);
  };
  useEffect(() => {
    getRejoinLeaveList();
  }, [activetwo, range])
  const showSelectedtwo = (index) => {
    setActivetwo(index);
  };

  const getLeaveList = async () => {
    const response = await GetLeaveList(token);
    if (response && response.statusCode === 200) {
      // console.log(response, "range")
      setLeaveList(response?.data?.leave_details.filter(item => {
        const startDate = new Date(item.start_date);
        const endDate = new Date(item.end_date);
        const rangeStartDate = new Date(range[0].startDate)
        const rangeEndDate = new Date(range[0].endDate)
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        rangeStartDate.setHours(0, 0, 0, 0);
        rangeEndDate.setHours(0, 0, 0, 0);
        return ((startDate >= rangeStartDate && startDate <= rangeEndDate) || (endDate >= rangeStartDate && endDate <= rangeEndDate));
      }));
    } else {
      errorMsg(response.message);
    }
  };
  const dfm = (date) => {
    return moment(date).format("DD/MM/yyyy")
  }
  const leaveListArray = Array.isArray(leaveList) ? leaveList : [];
  // console.log(leaveListArray)

  const appliedpendingcurrentItems = leaveListArray.filter((item) => item.status === "pending")
  const appliedapprovedcurrentItems = leaveListArray.filter((item) => item.status === "approved")
  const appliedRejectedcurrentItems = leaveListArray.filter((item) => item.status === "rejected")
  const appliedIntimatedcurrentItems = leaveListArray.filter((item) => item.status === "intimated")
  const cancelledpendingCurrentitems = leaveListArray.filter((item) => item.cancellation_status === "pending")
  const cancelledApprovedCurrentitems = leaveListArray.filter((item) => item.cancellation_status === "approved")
  const cancelledRejectedCurrentitems = leaveListArray.filter((item) => item.cancellation_status === "rejected")

  const getRejoinLeaveList = async () => {
    const response = await GetRejoinLeaveList(linkstwo[activetwo].toLowerCase(), token);
    if (response && response.statusCode === 200) {
      const listData = response?.data?.joining_letter.filter(item => {
        const startDate = new Date(item.start_date);
        const endDate = new Date(item.end_date);
        const rangeStartDate = new Date(range[0].startDate)
        const rangeEndDate = new Date(range[0].endDate)
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        rangeStartDate.setHours(0, 0, 0, 0);
        rangeEndDate.setHours(0, 0, 0, 0);
        return ((startDate >= rangeStartDate && startDate <= rangeEndDate) || (endDate >= rangeStartDate && endDate <= rangeEndDate));
      })
      setRejoinLeaveList(listData);
      const rejoinData = listData.map((rej) => ({
        start_date: rej.start_date,
        end_date: rej.end_date,
        no_of_days: rej.no_of_days,
        nature_of_leave: rej?.leave_detail?.nature_of_leave,
        hod_status: rej.hod_status,
        admin_status: rej.admin_status,
        director_status: rej.director_status,
        id: rej?.leave_detail?.id
      }))
      setRejoinLeaveList1(rejoinData)
    } else {
      errorMsg(response.message);
    }
  };

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    viewColumns: false,
  };

  const columns = [
    {
      name: "start_date",
      label: "Duration",
      options: {
        customBodyRender: (value, tableMeta) => {
          const endDate = tableMeta.rowData[1]
          return moment(value).format("DD MMM YY")
            + "-" + moment(endDate).format("DD MMM YY")
        },
        filter: false
      }
    },
    {
      name: "end_date",
      label: "End Date",
      options: {
        display: false,
        filter: false
      },
    },
    {
      name: "no_of_days",
      label: "Days",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div>{Number.isInteger(value) ? value : value.toFixed(2)}</div>
          )
        }
      }
    },
    {
      name: "nature_of_leave",
      label: "Types",
    },
    {
      name: "hod_status",
      label: "HOD",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={
                value === "approved"
                  ? "till-active"
                  : "not-active-wait" &&
                    value === "rejected"
                    ? "not-active"
                    : "not-active-wait"
              }
            >
              {value
                ? value
                : "-"}
            </div>
          )
        }
      }
    },
    {
      name: "admin_status",
      label: "Admin",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={value === "forwarded" ? "till-active" : "not-active-wait"}
            >
              {value ? value : "-"}
            </div>
          )
        }
      }
    },
    {
      name: "director_status",
      label: "Director",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={
                value === "approved" ? "till-active" : "not-active-wait" &&
                  value === "rejected" ? "not-active" : "not-active-wait"
              }
            >
              {value ? value : "-"}
            </div>
          )
        }
      }
    },

    {
      name: "id",
      label: "More Info",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Link
              to={`/app/Staff/StaffSpecificView/${value}`}
            >
              View Details
            </Link>
          )
        },
        filter: false,
        download: false
      }
    },
  ];
  const cancelledColumns = [

    {
      name: "start_date",
      label: "Duration",
      options: {
        customBodyRender: (value, tableMeta) => {
          const endDate = tableMeta.rowData[1]
          return moment(value).format("DD MMM YY")
            + "-" + moment(endDate).format("DD MMM YY")
        },
        filter: false
      }
    },
    {
      name: "end_date",
      label: "End Date",
      options: {
        display: false,
        filter: false
      },
    },
    {
      name: "no_of_days",
      label: "Days",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div>{Number.isInteger(value) ? value : value.toFixed(2)}</div>
          )
        }
      }
    },
    {
      name: "nature_of_leave",
      label: "Types",
    },
    {
      name: "cancellation_hod_status",
      label: "HOD",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={
                value === "approved"
                  ? "till-active"
                  : "not-active-wait" &&
                    value === "rejected"
                    ? "not-active"
                    : "not-active-wait"
              }
            >
              {value
                ? value
                : "-"}
            </div>
          )
        }
      }
    },
    {
      name: "cancellation_admin_status",
      label: "Admin",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={value === "forwarded" ? "till-active" : "not-active-wait"}
            >
              {value ? value : "-"}
            </div>
          )
        }
      }
    },
    {
      name: "cancellation_director_status",
      label: "Director",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={
                value === "approved" ? "till-active" : "not-active-wait" &&
                  value === "rejected" ? "not-active" : "not-active-wait"
              }
            >
              {value ? value : "-"}
            </div>
          )
        }
      }
    },

    {
      name: "id",
      label: "More Info",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Link
              to={`/app/Staff/StaffSpecificView/${value}`}
            >
              View Details
            </Link>
          )
        },
        filter: false,
        download: false
      }
    },
  ];

  const rejoinColumns = [
    {
      name: "start_date",
      label: "Duration",
      options: {
        customBodyRender: (value, tableMeta) => {
          const endDate = tableMeta.rowData[1]
          return moment(value).format("DD MMM YY") + "-" + moment(endDate).format("DD MMM YY")
        },
        filter: false
      }
    },
    {
      name: "end_date",
      label: "End Date",
      options: {
        display: false,
        filter: false
      },
    },
    {
      name: "no_of_days",
      label: "Days",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div>{Number.isInteger(value) ? value : value.toFixed(2)}</div>
          )
        }
      }
    },
    {
      name: "nature_of_leave",
      label: "Types",
    },
    {
      name: "hod_status",
      label: "HOD",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={
                value === "approved"
                  ? "till-active"
                  : "not-active-wait" &&
                    value === "rejected"
                    ? "not-active"
                    : "not-active-wait"
              }
            >
              {value
                ? value
                : "-"}
            </div>
          )
        }
      }
    },
    {
      name: "admin_status",
      label: "Admin",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={value === "forwarded" ? "till-active" : "not-active-wait"}
            >
              {value ? value : "-"}
            </div>
          )
        }
      }
    },
    {
      name: "director_status",
      label: "Director",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={
                value === "approved" ? "till-active" : "not-active-wait" &&
                  value === "rejected" ? "not-active" : "not-active-wait"
              }
            >
              {value ? value : "-"}
            </div>
          )
        }
      }
    },

    {
      name: "id",
      label: "More Info",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Link
              to={`/app/Staff/StaffSpecificView/${value}`}
            >
              View Details
            </Link>
          )
        },
        filter: false,
        download: false
      }
    },
  ];

  const InitimatedColumns = [
    {
      name: "start_date",
      label: "Duration",
      options: {
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD MMM YY (dddd)")
        },
        filter: false
      }
    },
    {
      name: "end_date",
      label: "End Date",
      options: {
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD MMM YY (dddd)")
        },
        filter: false
      }
    },
    {
      name: "no_of_days",
      label: "Days",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div>{Number.isInteger(value) ? value : value.toFixed(2)}</div>
          )
        }
      }
    },
    {
      name: "id",
      label: "More Info",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Link
              to={`/app/Staff/StaffSpecificView/${value}`}
            >
              View Details
            </Link>
          )
        },
        filter: false,
        download: false
      }
    },
  ];

  let cancelledLeave
  if (activeone === 0) {
    cancelledLeave = cancelledpendingCurrentitems
  } else if (activeone === 1) {
    cancelledLeave = cancelledApprovedCurrentitems
  } else if (activeone === 2) {
    cancelledLeave = cancelledRejectedCurrentitems
  }

  const dateFilterRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dateFilterRef.current && !dateFilterRef.current.contains(event.target)) {
      setDateFilterOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3">
                    <h6 className="labeltitle">Leave Request Status</h6>
                  </div>
                  <div className="col-lg-7">
                    <ul className="searchtopflex">
                      {linkstag.map((linkt, index) => {
                        return (
                          <li
                            onClick={() => { showSelectedtag(index); setRange(filterIntialState) }}
                            key={linkt}
                            className={
                              activetag === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {linkt}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="mt-5">
                  {activetag === 0 && (
                    <>
                      <ul className="searchtopflex">
                        {links.map((link, index) => {
                          return (
                            <li
                              onClick={() => { showSelected(index); setRange(filterIntialState) }}
                              key={link}
                              className={
                                active === index
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {link}
                            </li>
                          );
                        })}
                      </ul>
                      <div className="mt-3 d-flex align-items-center justify-content-end">
                        <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                          <input
                            className="form-control"
                            defaultValue={range[0].startDate ? ((range[0].startDate.getTime() === range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                          />
                          <span
                            className="material-symbols-outlined leave-filter-calendar"
                            onClick={() => setDateFilterOpen(true)}
                          >
                            calendar_month
                          </span>
                          {dateFilterOpen && (
                            <DateRangePicker
                              ranges={range}
                              onChange={handleSelect}
                              locale={enUS}
                            />
                          )}
                        </div>
                        {range[0].startDate &&
                          <div>
                            <span
                              class="material-symbols-outlined ms-3 filter-reset-button"
                              onClick={() => setRange(filterIntialState)}
                            >
                              cancel
                            </span>
                          </div>}
                      </div>
                      <>
                        {active === 0 && (
                          <MUIDataTable
                            data={appliedpendingcurrentItems}
                            columns={columns}
                            options={options}
                            className="mt-3"
                          />
                        )}
                        {active === 1 && (
                          <MUIDataTable
                            data={appliedapprovedcurrentItems}
                            columns={columns}
                            options={options}
                            className="mt-3"
                          />
                        )}
                        {active === 2 && (
                          <>
                            <MUIDataTable
                              data={appliedRejectedcurrentItems}
                              columns={columns}
                              options={options}
                              className="mt-3"
                            />
                          </>
                        )}
                        {active === 3 && (
                          <MUIDataTable
                            data={appliedIntimatedcurrentItems}
                            columns={InitimatedColumns}
                            options={options}
                            className="mt-3"
                          />
                        )}
                      </>
                    </>
                  )}
                  {activetag === 1 && (
                    <>
                      <ul className="searchtopflex">
                        {linksone.map((linkone, indexone) => {
                          return (
                            <li
                              onClick={() => { showSelectedone(indexone); setRange(filterIntialState) }}
                              key={linkone}
                              className={
                                activeone === indexone
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {linkone}
                            </li>
                          );
                        })}
                      </ul>
                      <div className="mt-3 d-flex align-items-center justify-content-end">
                        <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                          <input
                            className="form-control"
                            defaultValue={range[0].startDate ? ((range[0].startDate.getTime() === range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                          />
                          <span
                            className="material-symbols-outlined leave-filter-calendar"
                            onClick={() => setDateFilterOpen(true)}
                          >
                            calendar_month
                          </span>
                          {dateFilterOpen && (
                            <DateRangePicker
                              ranges={range}
                              onChange={handleSelect}
                              locale={enUS}
                            />
                          )}
                        </div>
                        {range[0].startDate &&
                          <div>
                            <span
                              class="material-symbols-outlined ms-3 filter-reset-button"
                              onClick={() => setRange(filterIntialState)}
                            >
                              cancel
                            </span>
                          </div>}
                      </div>
                      <MUIDataTable
                        data={cancelledLeave}
                        columns={cancelledColumns}
                        options={options}
                        className="mt-3"
                      />
                    </>
                  )}
                  {activetag === 2 && (
                    <>
                      <ul className="searchtopflex">
                        {linkstwo.map((linkone, indexone) => {
                          return (
                            <li
                              onClick={() => { showSelectedtwo(indexone); setRange(filterIntialState) }}
                              key={linkone}
                              className={
                                activetwo === indexone
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {linkone}
                            </li>
                          );
                        })}
                      </ul>
                      <div className="mt-3 d-flex align-items-center justify-content-end">
                        <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                          <input
                            className="form-control"
                            defaultValue={range[0].startDate ? ((range[0].startDate.getTime() === range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                          />
                          <span
                            className="material-symbols-outlined leave-filter-calendar"
                            onClick={() => setDateFilterOpen(true)}
                          >
                            calendar_month
                          </span>
                          {dateFilterOpen && (
                            <DateRangePicker
                              ranges={range}
                              onChange={handleSelect}
                              locale={enUS}
                            />
                          )}
                        </div>
                        {range[0].startDate &&
                          <div>
                            <span
                              class="material-symbols-outlined ms-3 filter-reset-button"
                              onClick={() => setRange(filterIntialState)}
                            >
                              cancel
                            </span>
                          </div>}
                      </div>
                      <MUIDataTable
                        data={activetwo === 0 ? rejoinLeaveList : rejoinLeaveList1}
                        columns={rejoinColumns}
                        options={options}
                        className="mt-3"
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section >
      </div >
    </>
  );
};

export default Staffleavestatus;
